module.exports = __webpack_public_path__ + "img/landing-page-previews.64237045.png";